import { generatePath } from 'react-router-dom'
import { TEMPLATE_BINDERS_PATH } from 'paths'
import { Workspace } from 'types'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Templates } from 'blaze-ui/icons'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuTemplateBindersItem = ({ workspace, onPress }: Props) => (
  <NavMenuItem
    icon={Templates}
    activeIcon={Templates}
    to={generatePath(TEMPLATE_BINDERS_PATH, { workspaceId: workspace.id })}
    onPress={onPress}
    label="Templates Admin"
  />
)

export { NavMenuTemplateBindersItem }
